/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit } from '@angular/core';
import { GenericTableData } from 'src/app/sharedServices/generic-table-data.service';

@Component({
  selector: 'app-upload-content-component',
  templateUrl: './upload-content.component.html',
})
export class UploadContentComponent implements OnInit {

  columnHeader: any;
  constructor(
    public contentItemsManagementService: GenericTableData,
  ) {
    this.contentItemsManagementService.setTableHeader(this.setColumnHeaders());
  }

  enabledDropdown = true;

  ngOnInit() {
    this.contentItemsManagementService.setTableDataList(null);
  }

  setColumnHeaders() {
    this.columnHeader = {
      checkBox: 'checkBox',
      uploadProgress: 'Upload Progress',
      //imageData: 'Image',
      extendedName: 'Extended Name',
      extension: 'Extension',
      relativeFileLocation: 'Relative File Path',
      webServiceId: 'FittingEntryID'}

    return this.columnHeader;

    }
}
